'use client';

import { SessionProvider } from 'next-auth/react';
import type { Session } from 'next-auth';
import type { ReactNode } from 'react';
import { BASE_PATH } from '@/app/components/search/utils/path';

export default function NextAuthProvider({ children, session }: { children: ReactNode; session: Session | null }) {
  return (
    <SessionProvider basePath={`${BASE_PATH}/api/auth`} session={session}>
      {children}
    </SessionProvider>
  );
}
